//libs
// import Swiper from 'swiper/bundle'
import Swiper from './lib/_swiper-bundle.min.js'
// import Lazy from './lib/_lazysizes.min.js'

// iOS/Safariでbehavior: 'smooth'が動かないためポリフィルを読み込む
import smoothscroll from 'smoothscroll-polyfill'
smoothscroll.polyfill()

//scripts
import { nav } from './common/_nav'
import { setGoogleFonts } from './common/_fonts'
import { preventImgs } from './common/_prevent'

import { progress } from './common/_progress'

import { scrollProgress } from './common/_scroll-progress'
import { prevTop } from './common/_prev-top'
import { smoothScroll } from './common/_smooth-scroll'

import { videoContent } from './common/_video'
// import { tab } from './common/_tab'
import { map } from './common/_map'
import { accordion } from './common/_accordion'

// Swiper
const $slider = document.querySelector('.js-slider')
const initialSlideSlider = Math.floor( Math.random() * (5 - 0) ) + 0
// alert(initialSlideSlider)

const sliderOption = {
  loop: true,
  effect: 'fade',
  speed: 1000,
  // slidesPerView: 1,
  // autoplay: {
    // delay: 3000,
    // disableOnInteraction: false,
  // },
  initialSlide: initialSlideSlider,
  // lazy: true,
  pagination: {
    el: '.swiper-pagination-slider',
    clickable: true,
    renderBullet: function (t, e) {
      return '<div class="'.concat(e,'">\n<svg viewBox="0 0 30 30" width="30" height="30" xml:space="preserve" id="svg" xmlns="http://www.w3.org/2000/svg">\n<circle class="p-homeHero__loader" cx="17" cy="17" r="8.5" stroke="#fff" fill="none" stroke-width="2" stroke-linecap="round"></circle>\n<circle class="p-homeHero__circle" cx="17" cy="17" r="8.5" stroke="#fff" fill="none" stroke-width="2" stroke-linecap="round"></circle>\n</svg>\n</div>')
    },
  },
  // breakpoints: {
  //   768: {
  navigation: {
    nextEl: '.swiper-button-next',
    prevEl: '.swiper-button-prev',
  },
  //   }
  // },
}

const item = document.querySelectorAll('.p-homeCarousel__item')
const initialSlideCarousel = Math.floor( Math.random() * (item.length - 0) ) + 0

const carouselOption = {
  loop: true,
  speed: 800,
  slidesPerView: 2.14,
  centeredSlides: true,
  initialSlide: initialSlideCarousel,
  // lazy: true,
  // watchSlidesVisibility: true,
  freeMode: true,
  freeModeMomentumRatio: 0.5,
  pagination: {
    el: '.swiper-pagination-carousel',
    clickable: true,
  },
  spaceBetween: 2,
  breakpoints: {
    768: {
      slidesPerView: 7.36,
      spaceBetween: 20,
    }
  },
}


const swiper = () => {
  const slider = new Swiper('.js-slider', sliderOption)
  const carousel = new Swiper('.js-carousel', carouselOption)

  slider.params.autoplay.disableOnInteraction = false

  setTimeout(() => {
    slider.autoplay.start()
  }, 1000)

  const button = document.querySelector('.js-homeButton')
  const loaders = document.querySelectorAll('.p-homeHero__loader')
  const videos = document.querySelectorAll('video')
  // console.log(videos.length)
  button.addEventListener('click', () => {
    if (!button.classList.contains('is-paused')) {
      for (let i = 0; i < loaders.length; i++) {
        // slider.pagination.init()
        loaders[i].style.animation = 'none'
      }
      button.classList.add('is-paused')
      slider.autoplay.stop()
      for (let i = 0; i < videos.length; i++) {
        videos[i].pause()
      }
    } else {
      for (let i = 0; i < loaders.length; i++) {
        // slider.pagination.update()
        loaders[i].style.animation = 'loading 4s ease-in'
      }
      button.classList.remove('is-paused')
      setTimeout(() => {
        slider.autoplay.start()
      }, 1000)
      for (let i = 0; i < videos.length; i++) {
        videos[i].play()
      }
    }
  })
}

if ($slider) {
  swiper()
}

// Navigation
setGoogleFonts()
nav()
preventImgs()

// localStorage Progress Bar
progress()

// Scroll Progress Bar
scrollProgress()

// Prev Top
prevTop()

// Smooth Scroll
smoothScroll()

// 動画出しわけ
videoContent()

// Tab
// tab()

// Map Scroll
map()

// Items Accordion
accordion()
